<template> 
     <router-view></router-view>
</template> 
<script>
    export default {
        name:'goods',
        data () {
            return {  
            }
        },
       
        computed: {
          
            
        },
        methods: {
               
           
            
        },
      
        mounted: function(){
            var that = this;
          
        }
    }
</script>  
<style>
    
</style>
     